import { styled } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import Box from '@mui/material/Box';

const DEFAULT_DATA_ROW_HEIGHT = 52;
const DEFAULT_HEADERS_ROW_HEIGHT = 42;

const ESimProfileLoaderRoot = styled('div', { name: 'ESimProfileLoader' })(({ theme }) => ({
  height: 2 * DEFAULT_DATA_ROW_HEIGHT + DEFAULT_HEADERS_ROW_HEIGHT,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: theme.palette.background.paper,
    '& > *': {
      backgroundColor: `${theme.palette.background.paper} !important`,
    },
  },
}));

export const ESimProfileLoader = () => {
  const apiRef = useGridApiContext();

  return (
    <Box sx={{ width: apiRef.current.getRootDimensions().viewportInnerSize.width }}>
      <ESimProfileLoaderRoot>
        <CircularProgress color="inherit" />
      </ESimProfileLoaderRoot>
    </Box>
  );
};
